import JobPosition from '../../pages/jobPosition'

const jobPositionRoute = [
  {
    path: '/JobPosition',
    name: 'JobPosition',
    component: JobPosition
  }
]

export default jobPositionRoute



// WEBPACK FOOTER //
// ./src/router/JobPosition/index.js